var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeamless(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27557 0H16.5V6.38462C18.2702 6.38462 19.7051 7.81953 19.7051 9.58972C19.7051 11.3599 18.2702 12.7948 16.5 12.7948V19.1794H8.27557C7.26475 19.1794 6.43648 18.3519 6.43648 17.3403V13.7069L11.6824 9.58972L6.43719 5.47253V1.83909C6.43719 0.827557 7.26404 0 8.27557 0ZM29.4156 4.35231V6.54587H33V12.6336H29.4156V14.8271L22.7426 9.58972L29.4156 4.35231ZM3.58442 4.35231V6.54587H0V12.6336H3.58442V14.8271L10.2574 9.58972L3.58442 4.35231ZM24.7237 0H17.3801V5.59969C19.2128 6.00245 20.5852 7.63626 20.5852 9.58972C20.5852 11.5432 19.2135 13.177 17.3801 13.5798V19.1794H24.7244C25.736 19.1794 26.5635 18.3519 26.5635 17.3403V13.7069L21.3176 9.58972L26.5628 5.47253V1.83838C26.5628 0.827558 25.7353 0 24.7237 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamless);
export default __webpack_public_path__ + "static/media/seamless.6983bded05b3421311dcd244066bc1b6.svg";
export { ForwardRef as ReactComponent };